<template>
  <z-card class="zoox-component zoox-filter-card" height="100%" width="100%">
    <template #content>
      <div class="zoox-filter-title">
        <strong> {{ title }} </strong>
        <v-icon class="zoox-filters-title-close" @click="$emit('close')"
          >$close_rounded</v-icon
        >
      </div>

      <z-select
        v-model="filterType"
        required
        :label="$t('filter_type')"
        :items="filterTypes"
      ></z-select>
      <z-select
        v-if="currentFilter.options"
        v-model="filterValue"
        required
        :disabled="!filterType"
        :label="currentFilter.label"
        :items="currentFilter.options"
      ></z-select>
      <z-input
        v-else
        v-model="filterValue"
        required
        :disabled="!filterType"
        :label="currentFilter.label"
      ></z-input>
      <div class="apply-container">
        <z-btn
          primary
          confirmation
          icon="$check_rounded"
          :disabled="!isValid"
          :text="$t('apply')"
          @click="onAddFilter"
        />
      </div>

      <div class="zoox-filters-container">
        <v-divider class="my-2"></v-divider>
        <z-filter-item-card
          v-for="(filter, index) of value"
          :key="index"
          class="my-1"
          :label="filter.type"
          :value="filter.value"
          @remove="onRemoveFilter(filter)"
        ></z-filter-item-card>
      </div>

      <v-card-actions class="zoox-filter-actions">
        <z-btn
          class="action-btn"
          icon="$view_list_rounded"
          :text="$t('see_saved_filters')"
        />
        <v-spacer></v-spacer>
        <z-btn
          primary
          class="action-btn"
          icon="$save_rounded"
          :text="$t('save_filters')"
        />
      </v-card-actions>
    </template>
  </z-card>
</template>

<script>
/**
 * @displayName Filter Card
 */
export default {
  name: 'ZFilterCard',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Titulo do card
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Array dos intens do filtro
     *
     * @typedef Object {type:string,label:string,options:array}
     */
    filters: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      filterType: null,
      filterValue: '',
    }
  },
  computed: {
    filterTypes() {
      return this.filters.map((filter) => filter.type)
    },
    currentFilter() {
      return (
        this.filters.find((filter) => filter.type === this.filterType) || {}
      )
    },
    isValid() {
      return this.filterType && this.filterValue
    },
  },
  mounted() {
    this.filterType = this.filters[0].type
  },
  methods: {
    onAddFilter() {
      const filter = {
        type: this.filterType,
        label: this.currentFilter.label,
        value: this.filterValue,
      }
      const filters = [...this.value, filter]

      this.filterValue = ''
      this.$emit('change', filters)
    },
    onRemoveFilter(filter) {
      const filters = this.value.filter((f) => f !== filter)

      this.$emit('change', filters)
    },
  },
  i18n: {
    messages: {
      pt: {
        filter_parameters: 'Parâmetros de Filtro',
        filter_type: 'Tipo do filtro',
        apply: 'Aplicar',
        see_saved_filters: 'Ver Filtros <br/>Salvos',
        save_filters: 'Salvar <br/>Filtros',
      },
      es: {
        filter_parameters: 'Parámetros de filtro',
        filter_type: 'Tipo de filtro',
        apply: 'Aplicar',
        see_saved_filters: 'Ver Filtros <br/>Guardados',
        save_filters: 'Guardar<br/>Filtros',
      },
      en: {
        filter_parameters: 'Filter Parameters',
        filter_type: 'Filter Type',
        apply: 'Apply',
        see_saved_filters: 'See Saved<br/>Filters',
        save_filters: 'Save <br/>Filters',
      },
      fr: {
        filter_parameters: 'Paramètres du filtre',
        filter_type: 'Type de filtre',
        apply: 'Appliquer',
        see_saved_filters: 'Voir les filtres<br/>enregistrés',
        save_filters: 'Enregistrer<br/>les filtres',
      },
      tr: {
        filter_parameters: 'Filtre Parametreleri',
        filter_type: 'Filtre Türü',
        apply: 'Uygula',
        see_saved_filters: 'Kaydedilmiş<br/>Filtreleri Görüntüle',
        save_filters: 'Filtreleri <br/>Kaydet',
      },
    },
  },
}
</script>

<style lang="scss">
.zoox-filter-card {
  display: grid !important;
  grid-template-rows: repeat(4, 1fr) 12fr 1fr;
  max-height: 100%;
  padding: 8px;

  .apply-container {
    text-align: end;
  }

  .zoox-filter-title {
    min-height: 64px;
  }

  .zoox-filters-container {
    overflow-y: auto;
    margin-top: 20px;
  }

  .zoox-filters-title-close {
    position: absolute !important;
    right: 8px;
  }

  .action-btn {
    span {
      font-size: 0.75rem;
    }
    max-width: 50%;
    width: 48%;
  }
}
</style>
